import { render, staticRenderFns } from "./MenuDisplayWidget.vue?vue&type=template&id=37043758&scoped=true&"
import script from "./MenuDisplayWidget.vue?vue&type=script&lang=js&"
export * from "./MenuDisplayWidget.vue?vue&type=script&lang=js&"
import style0 from "./MenuDisplayWidget.vue?vue&type=style&index=0&id=37043758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37043758",
  null
  
)

export default component.exports